import React from 'react';
import './index.css';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';
import loader from '@monaco-editor/loader';
import * as monaco from 'monaco-editor';

// Configure Monaco Editor to use local npm package instead of CDN
// This prevents loading from cdn.jsdelivr.net which violates Content Security Policy on production
loader.config({ monaco });

const app = (
    <Provider store={store}> 
                    <App />
    </Provider>
);
const root = createRoot(document.getElementById('root'));

root.render(app);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
